import React, { ReactElement } from 'react';
import {
  Redirect, Route, RouteProps,
} from 'react-router-dom';

import { LocationDescriptor } from 'history';

import { PageNotFoundDialog } from '@app/common/components/PageNotFoundDialog/PageNotFoundDialog';

export interface ConditionalRouteProps extends RouteProps {
  /**
   * if condition is true children are rendered
   */
  readonly condition: undefined | boolean | (() => boolean);
}

export interface WithElementFallbackProps extends ConditionalRouteProps {
  /**
   * if condition is false render fallback elements
   */
  readonly fallback: ReactElement | ReactElement[]
}

const WithElementFallback: React.FC<WithElementFallbackProps> = ({
  condition,
  fallback,
  children,
  ...routeProps
}) => (
  <Route {...routeProps}>
    {
        (typeof condition === 'function' ? condition() : condition)
          ? children
          : fallback
      }
  </Route>
);

export interface WithRedirectFallbackProps extends ConditionalRouteProps {
  /**
   * if condition is false route redirects to provided fallback
   */
  readonly fallback: LocationDescriptor
}

const WithRedirectFallback: React.FC<WithRedirectFallbackProps> = ({
  fallback,
  ...props
}) => (<WithElementFallback fallback={<Redirect to={fallback} />} {...props} />);

const WithNotFoundFallback: React.FC<ConditionalRouteProps> = (
  props,
) => (<WithElementFallback fallback={<PageNotFoundDialog />} {...props} />);

export const ConditionalRoute = {
  WithElementFallback,
  WithRedirectFallback,
  WithNotFoundFallback,
};
